import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../lib/analytics";

/**
 * Fires a GA4/Meta page_view on every React Router location change.
 * Must be rendered inside <BrowserRouter>. Renders nothing.
 */
export function RouteAnalytics() {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    // Small delay lets document.title update after the new route renders.
    const id = window.setTimeout(() => {
      trackEvent("page_view", {
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
      first.current = false;
    }, 50);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
